/**
 * Lieferung & Montage
 *
 * Aktualisiert die serverseitig gerenderte Auswahl beim Variantenwechsel.
 * Alle Texte kommen aus den Block-Einstellungen (data-Attribute) oder aus den
 * in Liquid vorberechneten Werten im JSON - hier stehen bewusst keine
 * uebersetzbaren Zeichenketten.
 */
(() => {
  const KEYS_NEXT = ['ArrowRight', 'ArrowDown'];
  const KEYS_PREVIOUS = ['ArrowLeft', 'ArrowUp'];

  class NdlDeliveryMontage extends HTMLElement {
    connectedCallback() {
      const dataScript = this.querySelector('[data-ndl-delivery-data]');

      try {
        this.data = JSON.parse(dataScript?.textContent || '[]');
      } catch (error) {
        this.data = [];
      }

      if (!this.data.length) return;

      this.deliveryIndex = Number(this.dataset.deliveryIndex);
      this.pickupValue = this.dataset.pickupValue;
      this.premiumValue = this.dataset.premiumValue;
      this.form = document.getElementById(this.dataset.formId);
      this.variantElement =
        this.form?.querySelector('product-variants') ||
        document.querySelector(`product-variants[form-id="${this.dataset.formId}"]`);

      this.buttons = [...this.querySelectorAll('[data-delivery-value]')];
      this.leadTime = this.querySelector('[data-lead-time]');
      this.leadLabel = this.querySelector('[data-lead-label]');
      this.leadValue = this.querySelector('[data-lead-value]');

      this.buttons.forEach((button) => {
        button.addEventListener('click', () => this.selectDelivery(button.dataset.deliveryValue));
        button.addEventListener('keydown', (event) => this.onKeydown(event));
      });

      this.form?.addEventListener('variant:changed', (event) => this.render(event.detail.variant));

      const selectedId = this.form?.querySelector('[name="id"]')?.value;
      const initial =
        this.data.find((variant) => String(variant.id) === String(selectedId)) || this.data[0];

      this.render(initial);
    }

    /** Variante mit gleicher Optionskombination, aber anderer Lieferoption. */
    pairFor(value) {
      if (!this.current) return undefined;

      return this.data.find((variant) =>
        variant.options.every((option, index) =>
          index === this.deliveryIndex ? option === value : option === this.current.options[index],
        ),
      );
    }

    selectDelivery(value) {
      const variant = this.pairFor(value);

      if (variant && this.variantElement?.selectVariant) {
        this.variantElement.selectVariant(variant.id);
        return;
      }

      const nativeInput = [
        ...document.querySelectorAll(`input[name="option${this.deliveryIndex + 1}"]`),
      ].find((input) => input.form?.id === this.dataset.formId && input.value === value);

      nativeInput?.click();
    }

    /** Pfeiltasten-Navigation innerhalb der Radiogruppe. */
    onKeydown(event) {
      const currentIndex = this.buttons.indexOf(event.currentTarget);
      let nextIndex = null;

      if (KEYS_NEXT.includes(event.key)) nextIndex = (currentIndex + 1) % this.buttons.length;
      if (KEYS_PREVIOUS.includes(event.key))
        nextIndex = (currentIndex - 1 + this.buttons.length) % this.buttons.length;
      if (event.key === 'Home') nextIndex = 0;
      if (event.key === 'End') nextIndex = this.buttons.length - 1;

      if (nextIndex === null) return;

      event.preventDefault();
      const nextButton = this.buttons[nextIndex];
      nextButton.focus();
      this.selectDelivery(nextButton.dataset.deliveryValue);
    }

    render(variant) {
      if (!variant) return;

      this.current = this.data.find((item) => String(item.id) === String(variant.id)) || this.current;

      if (!this.current) return;

      const activeValue = this.current.options[this.deliveryIndex];
      const isPickup = activeValue === this.pickupValue;

      this.buttons.forEach((button) => {
        const selected = button.dataset.deliveryValue === activeValue;
        button.setAttribute('aria-checked', String(selected));
        button.tabIndex = selected ? 0 : -1;
      });


      const selectedButton = this.buttons.find((button) => button.dataset.deliveryValue === activeValue);
      const selectedTitle = selectedButton?.querySelector('.ndl-delivery-montage__option-title')?.textContent?.trim() || activeValue || '';
      this.dispatchEvent(new CustomEvent('ndl:delivery-changed', {
        bubbles: true,
        detail: { formId: this.dataset.formId, title: selectedTitle },
      }));

      const leadValue = isPickup ? this.current.pickupText : this.current.premiumText;
      const leadLabel = isPickup ? this.dataset.pickupLeadLabel : this.dataset.premiumLeadLabel;
      const hasLeadValue = Boolean(leadValue);

      if (this.leadLabel) this.leadLabel.textContent = leadLabel || '';
      if (this.leadValue) this.leadValue.textContent = leadValue || '';
      if (this.leadTime) this.leadTime.hidden = !hasLeadValue;
    }
  }

  if (!customElements.get('ndl-delivery-montage')) {
    customElements.define('ndl-delivery-montage', NdlDeliveryMontage);
  }
})();
